/**
 * all actions for documents state
 *
 * Created by Paul on 20/5/19
 */

import C from '../constants'


// action to set documents loader
export const showDocumentsLoader = booleanVal => {
    return {
        type: C.SET_DOCUMNENTS_LOADER,
        payload: booleanVal
    }
}

// action to set document data
export const showDocumentsData = objectVal => {
    return {
        type: C.SET_DOCUMNENTS_DATA,
        payload: objectVal
    }
}

// action to set the document categories
export const setDocumentCategories = documentCategories => {
    return {
        type: C.SET_DOC_CATEGORIES,
        payload: documentCategories
    }
}

// action to set documents data
export const setDocusignData = objectVal => {
    return {
        type: C.SET_DOCUSIGN_DATA,
        payload: objectVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */
// call the action to fetch the funds documents
export const getDocumentsData = objectVal => {
    return {
        type: C.FETCH_DOCUMNENTS_DATA,
        payload: objectVal
    }
}

// call the action to delete a document
export const deleteDocument = objectVal => {
    return {
        type: C.DELETE_DOCUMENT,
        payload: objectVal
    }
}

// call the action to fetch Member documents details
export const getDocumentsCategories = () => {
    return {
        type: C.FETCH_DOC_CATEGORIES,
    }
}

// call the action to fetch Member documents details
export const clearDocumentsData = () => {
    return {
        type: C.CLEAR_DOCUMENTS_DATA,
    }
}

// call the action to fetch documents data
export const getDocusignData = objectVal => {
    return {
        type: C.GET_DOCUSIGN_DATA,
        payload: objectVal
    }
}


// WEBPACK FOOTER //
// ./src/actions/documentsActions.js